import { useEffect } from 'react';
import { useAuth } from '@/hooks/use-auth';

/** Converte #RRGGBB em oklch aproximado via CSS `color-mix` não é possível; usamos o hex direto. */
function applyBrand(color: string | null) {
  const root = document.documentElement;
  if (color && /^#[0-9a-fA-F]{6}$/.test(color)) root.style.setProperty('--brand-primary', color);
  else root.style.removeProperty('--brand-primary');
}

/** Aplica a cor primária configurada no tenant ativo. */
export function BrandTheme() {
  const { tenant } = useAuth();
  useEffect(() => {
    applyBrand(tenant?.primaryColor ?? null);
    return () => applyBrand(null);
  }, [tenant?.primaryColor]);
  return null;
}
